import axios from 'axios';
import { attachBusyRetry } from './busyRetry';

// Create an axios instance to talk to our backend
// IMPORTANT: Use your actual Flask backend URL
const apiClient = attachBusyRetry(axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// This is the function your components will call
export const getCmsDetails = async (pageName, language) => {
  try {
    // We need a token for verification. Let's assume it's saved in localStorage after login.
    const token = localStorage.token; 

    if (!token) {
      console.error("Authentication token not found!");
      return null; // Or handle this more gracefully
    }

    // Now we make the POST request, just like your backend expects
    const response = await apiClient.post('/v1/cms/get-details', {
      token: token,
      page_name: pageName,
      language: language
    });

    // Your backend returns { message: "...", data: "..." }
    // We just want to return the actual data
    return response.data.data;

  } catch (error) {
    // Log any errors to the console for debugging
    console.error('Error fetching CMS details:', error);
    return null; // Return null if there was an error
  }
};